export const downloadUrl = (href, name) => {
  if (isIOS()) {
    setTimeout(() => {
      window.open(href, '_top');
    })
  } else {
    const link = document.createElement('a');
    link.href = href;
    link.download = name
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

function isIOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
}